import { createSlice } from "@reduxjs/toolkit";
import { IDeal } from "src/@types/deals";
import { CURRENT_DEAL_SLICE_NAME } from "./actions";
import {
  getDealReducer,
  createDealFromCloneReducer,
  createDealFromInquiryReducer,
  deleteDealReducer,
  inProgressDealReducer,
  cancelDealReducer,
  doneDealReducer,
} from "./reducers";

export interface CurrentDealState {
  isLoading: boolean;
  item: IDeal;
}

const initialState: CurrentDealState = {
  isLoading: false,
  item: null,
};

export const { reducer: currentDeal } = createSlice({
  name: CURRENT_DEAL_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getDealReducer(builder);
    createDealFromCloneReducer(builder);
    createDealFromInquiryReducer(builder);
    deleteDealReducer(builder);
    inProgressDealReducer(builder);
    cancelDealReducer(builder);
    doneDealReducer(builder)
  },
});
